import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enHomepage from './locales/en/homepage.json';
import hiHomepage from './locales/hi/homepage.json';
import mrHomepage from './locales/mr/homepage.json';
import enLenderPage from './locales/en/lenderPage.json';
import hiLenderPage from './locales/hi/lenderPage.json';
import mrLenderPage from './locales/mr/lenderPage.json';

const savedLanguage = localStorage.getItem('selectedLanguage') || 'en';

i18n
  .use(initReactI18next)
  .init({
    lng: savedLanguage,
    fallbackLng: 'en',
    debug: true,
    interpolation: { escapeValue: false },
    resources: {
      en: {
        homepage: enHomepage,
        lenderPage: enLenderPage
      },
      hi: {
        homepage: hiHomepage,
        lenderPage: hiLenderPage
      },
      mr: {
        homepage: mrHomepage,
        lenderPage: mrLenderPage
      }
    },
    ns: ['homepage', 'lenderPage'],
    defaultNS: 'homepage',
  });

export default i18n;